<template>
  <div>
    <Loading ref="loading"></Loading>
    <Dialog title="游戏类型" @close="isOpen = false" :open="isOpen" show-close>
      <div class="create-team">
        <Button class="btn-xh" width="18rem" @click="handleXHLogin"
          >星辉手游账号登录</Button
        >
        <Button class="btn-wx" width="18rem" @click="handleWxLogin"
          >微信登录（小游戏用户专享）</Button
        >
      </div>
    </Dialog>
  </div>
</template>

<script>
const LOGIN_URL =
  process.env.NODE_ENV === "development"
    ? "http://dev.m.rastargame.com:8083/#/login-new/pass"
    : "https://m.rastargame.com/dist/login-new/pass";
import Dialog from "@/components/dialog/index.vue";
import Button from "@/components/button/index.vue";
import Loading from "@/components/loading/index.vue";
export default {
  components: {
    Dialog,
    Button,
    Loading,
  },
  data() {
    return {
      // 开团身份（master 团长，member 成员）
      position: "",
      isOpen: false,
      groupId: "",
    };
  },
  methods: {
    open(position, groupId) {
      this.position = position;
      this.groupId = groupId;
      this.isOpen = true;
    },
    handleWxLogin() {
      localStorage.setItem("game_type", "xyx");
      this.isOpen = false;
      const urlInfo = [window.location.href.split("?")[0]];
      const params = [];
      if (this.position === "member") params.push("groupId=" + this.groupId);
      params.push("position=" + this.position);
      if (params.length > 0) {
        urlInfo.push(params.join("&"));
      }
      this.$refs.loading.show("正在登录...");
      window.addEventListener("popstate", () => {
        this.$refs.loading.hide();
      });
      window.location.href = urlInfo.join("?");
    },
    handleXHLogin() {
      localStorage.setItem("game_type", "sy");
      this.isOpen = false;
      const urlInfo = [window.location.href.split("?")[0]];
      const params = [];
      if (this.position === "member") params.push("groupId=" + this.groupId);
      params.push("position=" + this.position);

      if (params.length > 0) {
        urlInfo.push(params.join("&"));
      }
      this.$refs.loading.show("正在跳转登录...");
      window.addEventListener("popstate", () => {
        this.$refs.loading.hide();
      });
      window.location.href =
        LOGIN_URL + "?return=" + encodeURIComponent(urlInfo.join("?"));
    },
  },
};
</script>

<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: red;
}
.create-team {
  width: 100%;
  height: 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .btn-xh {
    max-width: 90%;
    border-radius: 0.4rem;
    background: rgb(232, 67, 65);
  }
  .btn-wx {
    margin-top: 1rem;
    max-width: 90%;
    border-radius: 0.4rem;
    background: rgb(0, 179, 9);
  }
}
</style>
